import { useQuery } from '@tanstack/react-query';
import { legalDocumentsSchema, myLegalSchema } from '@ailab/contracts';
import { apiRequest } from './http';

// Documentos legales vigentes (RF-09.01). La versión la decide el servidor.

export const MY_LEGAL_QUERY_KEY = ['me', 'legal'] as const;

export function useLegalDocuments() {
  return useQuery({
    queryKey: ['legal', 'documents'],
    queryFn: () => apiRequest('/legal/documents', legalDocumentsSchema),
    staleTime: 60 * 60 * 1000,
  });
}

/** Lo que la cuenta tiene pendiente de aceptar y lo que ya aceptó (RF-09.03). */
export function useMyLegal(enabled: boolean) {
  return useQuery({
    queryKey: MY_LEGAL_QUERY_KEY,
    queryFn: () => apiRequest('/me/legal', myLegalSchema),
    enabled,
  });
}
